// src/api/vehicleApi.js
import axiosInstance from "./axiosConfig";

export const getVehicles = () => {
  return axiosInstance.get("/vehicles"); // Llama a http://localhost:3001/api/vehicles
};

export const createVehicle = (vehicleData) => {
  return axiosInstance.post("/vehicles", vehicleData);
};

export const syncVehicles = () => axiosInstance.post("/vehicles/sync");
